import { InjectionToken } from "@angular/core";
import { AssignmentModalOptions } from "@vp/models";
import { IAssignmentService } from "./assignment-service.interface";

export const ASSIGNMENT_MODAL_OPTIONS = new InjectionToken<AssignmentModalOptions>(
  "ASSIGNMENT_MODAL_OPTIONS"
);
export const ASSIGNMENT_SERVICE = new InjectionToken<IAssignmentService>("ASSIGNMENT_SERVICE");
